import { Component, Input, Output, EventEmitter } from '@angular/core';


interface Article {
  nom: string;
  code: string;
  prix: number;
  quantite: number;
}

@Component({
  selector: 'app-resume-facture',
  templateUrl: './resume-facture.component.html',
  styleUrls: ['./resume-facture.component.css']
})
export class ResumeFactureComponent {
  @Input() articles: Article[] = [];
  @Input() client: any = null;
  @Output() genererFacture = new EventEmitter<void>();

  get total(): number {
    return this.articles.reduce((sum, a) => sum + a.prix * a.quantite, 0);
  }

  onConfirmer() {
    this.genererFacture.emit();
  }
}
